export default "__VITE_ASSET__1651764d__"